export default __webpack_public_path__ + "static/media/khat.13a1ddb3.jpg";